// File-based global middleware runs before the middleware that modules add at
// runtime (@nuxtjs/supabase's auth redirect, i18n). Without this, an unknown
// URL is sent to /auth with a 302 before Nuxt's own 404 check ever runs, which
// search engines read as a soft 404.
export default defineNuxtRouteMiddleware((to) => {
  if (to.matched.length === 0) {
    return abortNavigation(
      createError({ statusCode: 404, statusMessage: "Page Not Found", fatal: true }),
    );
  }
});
